import { render } from "./HotnewsView.vue?vue&type=template&id=ac4f5354&scoped=true"
import script from "./HotnewsView.vue?vue&type=script&lang=js"
export * from "./HotnewsView.vue?vue&type=script&lang=js"

import "./HotnewsView.vue?vue&type=style&index=0&id=ac4f5354&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac4f5354"]])

export default __exports__